import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";
import { httpClient } from "@/lib/http";
import {
  CandidacyInterest,
  CreateCandidacyInterestRequest,
  HttpResponse,
} from "@/types";

export function useCreateCandidacyInterest() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      candidacyId,
      createCandidacyInterestRequest,
    }: {
      candidacyId: string;
      createCandidacyInterestRequest: CreateCandidacyInterestRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/candidacy_interests`;
      const res = await httpClient.post<
        CandidacyInterest,
        HttpResponse<CandidacyInterest>,
        CreateCandidacyInterestRequest
      >(path, createCandidacyInterestRequest);

      return res.data;
    },
  });

  return mutation;
}
